import {
  Component,
  EventEmitter,
  Input,
  Output,
  effect,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

type ButtonVariant = 'primary' | 'secondary' | 'delete';
type ButtonAppearance = 'filled' | 'elevated' | 'outlined' | 'text' | 'tonal';

@Component({
  selector: 'crm-base-button',
  standalone: true,
  imports: [MatButton, MatIcon, MatProgressSpinner],
  templateUrl: './base-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './base-button.component.scss',
})
export class BaseButtonComponent {
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: ButtonVariant = 'primary';
  @Input() appearance?: ButtonAppearance;
  @Input() suffixIcon?: string = '';
  @Input() wide!: boolean | undefined;
  @Input() width?: number;
  @Output() clicked = new EventEmitter<MouseEvent>();

  private readonly _isLoading = signal(false);
  protected readonly isLoadingSig = this._isLoading.asReadonly();
  @Input() set isLoading(v: boolean) {
    this._isLoading.set(v);
  }
  @Input() set loading(v: boolean) {
    this._isLoading.set(v);
  }

  protected readonly showSpinner = signal(false);
  protected readonly showCheck = signal(false);

  private doneTimer: any = null;

  constructor() {
    let prev = this._isLoading();
    effect(() => {
      const curr = this._isLoading();

      if (curr) {
        this.clearTimer();
        this.showSpinner.set(true);
        this.showCheck.set(false);
      } else {
        this.showSpinner.set(false);
        if (prev) {
          this.showCheck.set(true);
          this.clearTimer();
          this.doneTimer = setTimeout(() => this.showCheck.set(false), 2000);
        } else {
          this.showCheck.set(false);
        }
      }
      prev = curr;
    });
  }

  onClick(ev: MouseEvent) {
    this.clicked.emit(ev);
  }

  private clearTimer() {
    if (this.doneTimer) {
      clearTimeout(this.doneTimer);
      this.doneTimer = null;
    }
  }
}
